import local_en from "@/locales/en";
import merge from "lodash.merge";
import { locales } from "@thegetty-private/getty-ui";
import { locales as radAppUtilsLocales } from "@thegetty-private/rad-app-utils";

// combine locale objects for each language
let en_extra = {};
let en = merge(
  locales.messages.en,
  radAppUtilsLocales.messages.en,
  local_en,
  en_extra
);
console.log(en);
// create and export a single locales object
export const messages = { en };
